import { ReportConfig } from '../../../dto/advi/advi.dto';

export type ReportWizardMode = 'organization' | 'station';

export interface ReportWizardContext {
  mode: ReportWizardMode;
  /** Locked location GUID in station mode */
  locationGuid?: string;
  locationName?: string;
  /** Edit existing advisory */
  adviId?: number;
  /** Initial config when editing */
  initialConfig?: ReportConfig;
  initialName?: string;
  initialDescription?: string;
}

export function isStationMode(ctx: ReportWizardContext): boolean {
  return ctx.mode === 'station';
}

export function canSave(ctx: ReportWizardContext): boolean {
  return ctx.mode === 'organization';
}

export function showAdviseringStep(ctx: ReportWizardContext): boolean {
  return ctx.mode === 'organization';
}

export function showLocationStep(ctx: ReportWizardContext): boolean {
  return ctx.mode === 'organization';
}

export function showGdprStep(ctx: ReportWizardContext): boolean {
  return ctx.mode === 'station';
}
